import UiHelper from './UiHelper';

class PrimaryNav
{
    static init()
    {
        // bind functions
        this.checkForSideNav = this.checkForSideNav.bind(this);

        // dom node references
        this.header = UiHelper.getNode('.js-site-header');
        this.headerInner = this.header.querySelector('.site-header__inner');
        this.branding = UiHelper.getNode('.js-header-branding');

        UiHelper.registerHandler('resize', this.checkForSideNav, 'throttle');
        this.checkForSideNav(null);
        this.header.classList.add('site-header--initiated');
    }

    static checkForSideNav(e)
    {
        // var a = UiHelper.getNode('.js-site-header').offsetWidth;
        // var b = UiHelper.getNode('.js-header-branding').offsetWidth;
        // var c = UiHelper.getPrimaryNavWidth();
        // console.log(`total width: ${a}`);
        // console.log(`branding: ${b}`);
        // console.log(`nav: ${c}`);
        // console.log(`rest: ${(a - b - c)}`)

        if (this.header.offsetWidth < 576) return; // no need to do any calculations, always hamburger menu

        //const availableSpace = this.header.offsetWidth - this.branding.offsetWidth - UiHelper.getPrimaryNavWidth();
        const availableSpace = this.headerInner.offsetWidth - this.branding.offsetWidth - UiHelper.getPrimaryNavWidth();
        if (availableSpace < 30)
        {
            // /console.log('add hamburger class');
            this.header.classList.add('site-header--hamburger');
        }
        else
        {
            // console.log('remove hamburger class');
            this.header.classList.remove('site-header--hamburger');
        }
    }
}

export default PrimaryNav;
